export class ListeningPostSettings {

  static lineOfBusiness: string;
  static brandingType: string;
  static logoImagePath: string;
  static surveyType: string;

}
